import { useContext } from 'react';

import type { GlobalStorageContextProps } from 'src/shared/providers/GlobalStorage';
import { globalStorageContext } from 'src/shared/providers/GlobalStorage';

const useGlobalStorageContext = (): GlobalStorageContextProps => {
  const context = useContext(globalStorageContext);
  return context;
};

export { useGlobalStorageContext };
